// --- FILE: src/App.jsx (CON LÓGICA DE ROLES ROBUSTA) ---
import React from 'react';
import { useAuth } from './contexts/AuthContext';

import AdminLoginPage from './pages/AdminLoginPage';
import AdminReportPage from './pages/AdminReportPage';
import PinScreenPage from './pages/PinScreenPage';
import EmployeeDashboardPage from './pages/EmployeeDashboardPage';
import LoadingSpinner from './components/common/LoadingSpinner';

function App() {
  const { user, activeEmployee, loading, adminView, userRole } = useAuth();

  // 1. Estado de Carga
  if (loading) {
    return <LoadingSpinner fullScreen={true} text="Iniciando sistema..." />;
  }

  // 2. Vista del Empleado (Máxima prioridad)
  if (activeEmployee) {
    return <EmployeeDashboardPage />;
  }

  // 3. Vistas para Usuarios Autenticados (sin PIN activo)
  if (user) {
    // Si el rol es 'admin', decide qué panel mostrar
    if (userRole === 'admin') {
      if (adminView === 'terminal') {
        return <PinScreenPage />;
      }
      return <AdminReportPage />;
    }
    // Si el rol es 'employee', lo manda directamente al terminal
    if (userRole === 'employee') {
      return <PinScreenPage />;
    }
  }

  // 4. Vista por Defecto (Login)
  // Si no hay usuario o no tiene un rol reconocido, va al login.
  return <AdminLoginPage />;
}

export default App;
